module.exports = __webpack_public_path__ + "img/philosophy_machine.ba53f41f.webp";